/**
 * File Attachment Input Component
 * Handles file input for product variants with piece_jointe field
 */

if (!customElements.get('file-attachment-input')) {
  class FileAttachmentInput extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Query elements in connectedCallback to ensure DOM is ready
      this.fileInput = this.querySelector('[data-file-input]');
      this.preview = this.querySelector('[data-file-preview]');
      this.fileName = this.querySelector('[data-file-name]');
      this.removeButton = this.querySelector('[data-action="remove-file"]');
      this.label = this.querySelector('.file-attachment-input__label');
      this.textarea = this.querySelector('[data-attachment-description]');
      
      this.setupEventListeners();
      this.setupVariantChangeListener();
    }

    disconnectedCallback() {
      this.removeVariantChangeListener();
    }

    setupEventListeners() {
      // Trigger file input when clicking the label/button
      if (this.label) {
        this.label.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.fileInput?.click();
        });
      }

      // Handle file selection
      if (this.fileInput) {
        this.fileInput.addEventListener('change', (e) => {
          // Stop propagation to prevent document-level listener from catching this
          e.stopPropagation();
          this.handleFileChange();
        });
      }

      // Handle textarea change - stop propagation to prevent interference
      if (this.textarea) {
        this.textarea.addEventListener('change', (e) => {
          e.stopPropagation();
        });
      }

      // Handle file removal
      if (this.removeButton) {
        this.removeButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.removeFile();
        });
      }
    }

    setupVariantChangeListener() {
      // Listen for variant changes to show/hide the file input
      this.variantChangeHandler = this.handleVariantChange.bind(this);
      document.addEventListener('change', this.variantChangeHandler);
    }

    removeVariantChangeListener() {
      if (this.variantChangeHandler) {
        document.removeEventListener('change', this.variantChangeHandler);
      }
    }

    handleVariantChange(event) {
      const target = event.target;
      
      // Only handle variant dropdown changes for the Modèle option
      // Ignore file input changes (they have a different class)
      if (!target.classList.contains('variant-dropdown__native-select')) {
        return;
      }
      
      const dropdown = target.closest('variant-dropdown');
      if (dropdown && dropdown.dataset.optionName === 'Modèle') {
        this.updateVisibility(target);
      }
    }

    updateVisibility(selectElement) {
      const selectedOption = selectElement.options[selectElement.selectedIndex];
      const hasPieceJointe = selectedOption?.dataset.pieceJointe === 'true';
      
      if (hasPieceJointe) {
        this.show();
      } else {
        this.hide();
        // Clear the file and textarea when hiding
        this.clearAll();
      }
    }

    clearAll() {
      this.removeFile();
      if (this.textarea) {
        this.textarea.value = '';
      }
    }

    show() {
      this.classList.remove('file-attachment-input--hidden');
    }

    hide() {
      this.classList.add('file-attachment-input--hidden');
    }

    handleFileChange() {
      const file = this.fileInput?.files?.[0];
      
      if (file) {
        // Update preview - use class instead of hidden attribute for consistency
        if (this.fileName) {
          this.fileName.textContent = file.name;
        }
        this.classList.add('file-attachment-input--has-file');
      } else {
        this.clearPreview();
      }
    }

    removeFile() {
      if (this.fileInput) {
        this.fileInput.value = '';
      }
      this.clearPreview();
    }

    clearPreview() {
      if (this.fileName) {
        this.fileName.textContent = '';
      }
      this.classList.remove('file-attachment-input--has-file');
    }
  }

  customElements.define('file-attachment-input', FileAttachmentInput);
}

